import { c as _c } from "react/compiler-runtime";
import useUser from 'shared/hooks/use-user';
import { FunnelStepInterface } from 'shared/types/payment-interface';
import { useControlledSwr } from '@systemeio/util';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { SALES_FUNNELS_API, SALES_FUNNEL_STEP_API } from 'modules/courses/courses/api/sales-funnels-api';
import { SalesFunnelInterface } from 'modules/courses/courses/types/sales-funnel-interface';
export function useSalesFunnels() {
  const $ = _c(3);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== user) {
    t1 = () => user && SALES_FUNNELS_API;
    $[1] = user;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return useControlledSwr(t1, fetcher);
}
export function useSalesFunnelSteps(activeFunnel) {
  const $ = _c(4);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== activeFunnel || $[2] !== user) {
    t1 = () => user && typeof activeFunnel === "number" && `${SALES_FUNNEL_STEP_API}/${activeFunnel}`;
    $[1] = activeFunnel;
    $[2] = user;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return useControlledSwr(t1, fetcher);
}